'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Reveal = require('./Reveal');

var _Reveal2 = _interopRequireDefault(_Reveal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Reveal2.default;


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/commonjs/elements/Reveal/index.js
// module id = 932
// module chunks = 168707334958949